import { render, staticRenderFns } from "./AppEngV3WrittenAssessment.vue?vue&type=template&id=2c396f05&scoped=true"
import script from "./AppEngV3WrittenAssessment.vue?vue&type=script&lang=ts"
export * from "./AppEngV3WrittenAssessment.vue?vue&type=script&lang=ts"
import style0 from "./AppEngV3WrittenAssessment.vue?vue&type=style&index=0&id=2c396f05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c396f05",
  null
  
)

export default component.exports